export const RoutingConstants = {
  dashboard: 'dashboard',
  movies: 'movies',
  genres: 'genres',
  carousel: 'carousel',
  notAuthorized: 'unauth',
  mustActivate: 'mustActivate',
  login: 'login',
  register: 'register',
  registered: 'registered',
  recoverPassword: 'recoverPassword',
  users: 'users',
  acl: 'acl',
  profile: 'profile',
  settings: 'profile/settings',
  params: {
    id: ':id',
    code: ':code',
    token: 'token',
    previousPage: 'previous',
  },
};
